import * as types from './action-types';

const baseState = {
    hasError: false,
    error: null,
    fetching: false,
    isFetchingLeadComplete: false,
    code: null
};

const defaultState = {
    ...baseState,
    leadComplete: {},
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
    case types.LEAD_COMPLETE_PENDING:
        return Object.assign({}, state, baseState, {
            fetching: true,
            isFetchingLeadComplete: true,
            code: null,
        });

    case types.LEAD_COMPLETE_FAILED:
        return Object.assign({}, state, baseState, {
            hasError: true,
            error: action.error,
            isFetchingLeadComplete: false,
            code: null,
        });

    case types.LEAD_COMPLETE_FAILURE:
        return Object.assign({}, state, baseState, {
            hasError: true,
            error: action.error || null,
            isFetchingLeadComplete: false,
            code: action.error.code || null,
        });

    case types.LEAD_COMPLETE_SUCCESS:
        return Object.assign({}, state, baseState, {
            leadComplete: action.res.data,
            isFetchingLeadComplete: false,
            code: action.res.code,
        });

    default:
        return Object.assign({}, state);
    }
};

export default reducer;
